module.exports = "/_next/static/images/Hero-81816e7e31ba567477bb013739ddff8d.webp";